import React, { useCallback, useEffect, useState } from "react";
import Header from "../layout/Header";
import Sidebar from "../layout/Sidebar";
import { Link } from "react-router-dom";
import axios from "axios";
import Pagination from "../Pagination/Pagination";
import Bus_img from "../../assets/images/bus_img.png";
import Swal from "sweetalert2";
import { baseUrl } from "../../config/baseUrl";
import { ToastMessgae } from "../utils/toast";
import BulkJobSchedulerUpload from "./BulkJobSchedulerUpload";
import BulkJobDoneUpload from "./BulkJobDoneUpload";

export default function JobSchedule() {
  const loginUser = JSON.parse(localStorage.getItem("user")) || {};
  const token = localStorage.getItem("token");

  const [scheduleData, setScheduleData] = useState([]);
  const [pageNumber, setPageNumber] = useState(1);
  const [pageLimit, setPageLimit] = useState(1);
  const [showdata, setShowdata] = useState("Active");
  const [extra, setExtra] = useState({});
  const [depoData, setDepoData] = useState([]);
  const [companyNameData, setCompanyNameData] = useState([]);
  const [paginationDetails, setPaginationDetails] = useState({});

  const [searchData, setSearchData] = useState({
    company: "",
    bus__depo: "",
    cleaning_type: "",
    Cleaning_type: "",
    assign_date: "",
    bus_bus_number: "",
    report_done: "",
  });



  const [exportLoader, setExportLoader] = useState(false);


  const handleDownloadReport = async () => {
    // Check if at least one filter is selected
    if (
      !searchData?.company &&
      !searchData?.bus__depo &&
      !searchData?.cleaning_type &&
      !searchData?.assign_date &&
      !searchData?.bus_bus_number &&
      
      (searchData?.report_done === "" ||
        searchData?.report_done === null ||
        typeof searchData?.report_done === "undefined")
    ) {
      // remove this toast error message because it is not needed 
      // ToastMessgae({
      //   code: 400,
      //   message: "Please select at least one filter to download the report.",
      // });
      // return;
    }


    if (!searchData?.assign_date) {
      setDateError("Please select date.")
      return
    }

    setExportLoader(true);
    try {
      const params = new URLSearchParams();

      // Add search filters as query parameters (matching the API field names)
      if (searchData?.company) params.append("company", searchData.company);
      if (searchData?.bus__depo)
        params.append("bus__depo", searchData.bus__depo);
      if (searchData?.cleaning_type)
        params.append("cleaning_type", searchData.cleaning_type);
      if (searchData?.assign_date)
        params.append("assign_date", searchData.assign_date);
      if (searchData?.bus_bus_number)
        params.append("bus__bus_number", searchData.bus_bus_number);
      if (
        searchData?.report_done !== "" &&
        searchData?.report_done !== null &&
        typeof searchData?.report_done !== "undefined"
      ) {
        params.append("report_done", String(searchData.report_done));
      }

      const url = params.toString()
        ? `${baseUrl}/module/admin/download-scheduler-excel/?${params.toString()}`
        : `${baseUrl}/module/admin/download-scheduler-excel/`;

      const response = await axios.get(url, {
        headers: {
          Authorization: "Token " + token,
        },
        responseType: "blob", // Important for file downloads
      });

      // Create a blob from the response
      const blob = new Blob([response.data], {
        type:
          response.headers["content-type"] ||
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      // Create a temporary URL and trigger download
      const urlObject = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = urlObject;
      link.setAttribute("download", `scheduler_export.xlsx`);
      document.body.appendChild(link);
      link.click();

      // Clean up
      link.remove();
      window.URL.revokeObjectURL(urlObject);
      ;
      setDateError("")
    } catch (error) {
      console.error("Error downloading scheduler report:", error);
      ToastMessgae({
        code: 500,
        message: "Failed to download scheduler report. Please try again.",
      });
    } finally {
      setExportLoader(false)
    }
  };

  const ChangeHandler = (e) => {
    const { name, value, type } = e.target;
    let val = value;

    if (name === "report_done") {
      if (value === "true") val = true;
      else if (value === "false") val = false;
      else val = ""; // empty option
    }

    // For text fields (bus number etc.) avoid accidental leading spaces
    if (type === "text" && typeof val === "string") {
      // keep user's ability to type; only remove leading spaces
      val = val.replace(/^\s+/, "");
    }

    setSearchData((curr) => ({ ...curr, [name]: val }));
  };

  // Fetch list (with current page & search params)
  const JobScheduleListApi = async (page = pageNumber) => {
    try {
      setShowdata("Active");
      const qs = new URLSearchParams();
      qs.set("page", page);
      if (searchData.company) qs.set("company", searchData.company);
      if (searchData.bus__depo) qs.set("bus__depo", searchData.bus__depo);
      if (searchData.cleaning_type)
        qs.set("cleaning_type", searchData.cleaning_type);
      if (searchData.assign_date) qs.set("assign_date", searchData.assign_date);
      if (searchData.bus_bus_number)
        qs.set("bus__bus_number", searchData.bus_bus_number);
      // report_done might be boolean
      if (
        searchData.report_done !== "" &&
        searchData.report_done !== null &&
        typeof searchData.report_done !== "undefined"
      ) {
        qs.set("report_done", String(searchData.report_done));
      }

      const url = `${baseUrl}/module/admin/adminscheduler-viewset?${qs.toString()}`;

      const response = await axios(url, {
        method: "GET",
        headers: {
          Authorization: "Token " + token,
        },
      });

      // Defensive: set empty array if backend returns no data
      if (response?.data) {
        setPaginationDetails(response.data?.extra || {});
        setScheduleData(response.data?.data || []);
        setPageLimit(response.data?.extra?.total || 1);
        setExtra(response.data?.extra || {});
      } else {
        setScheduleData([]);
        setPaginationDetails({});
        setPageLimit(1);
        setExtra({});
      }
    } catch (error) {
      // You might want to handle different status codes here
      console.error("JobScheduleListApi error:", error);
      alert(
        error?.message
          ? `${error.message}, Some error from server`
          : "Some error from server"
      );
      // Keep UI stable: show no records
      setScheduleData([]);
    }
  };

  const depo = useCallback(
    async (companyId = null) => {
      try {
        let url = `${baseUrl}/module/admin/depo-list`;

        // For SUPER_ADMIN, if company is selected, filter depo list by company
        if (loginUser?.user_type === "SUPER_ADMIN" && companyId) {
          url += `?company=${companyId}`;
        }

        const response = await axios(url, {
          method: "GET",
          headers: { Authorization: "Token " + token },
        });
        setDepoData(response?.data?.data || []);
      } catch (error) {
        console.error("depo fetch error:", error);
        setDepoData([]);
      }
    },
    [loginUser?.user_type, token]
  );
  useEffect(() => {
    // Refresh list when page changes
    JobScheduleListApi(pageNumber);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageNumber]);

  useEffect(() => {
    // For SUPER_ADMIN: only fetch depo list if company is selected
    // For other users: fetch depo list normally
    if (loginUser?.user_type === "SUPER_ADMIN") {
      companyName();
      // Only fetch depo list if company is selected
      if (searchData.company) {
        depo(searchData.company);
      } else {
        setDepoData([]); // Clear depo list when no company selected
      }
    } else {
      depo();
      companyName();
    }
    // initial load
    JobScheduleListApi(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // For SUPER_ADMIN: Fetch depo list when company changes
  useEffect(() => {
    if (loginUser?.user_type === "SUPER_ADMIN") {
      if (searchData.company) {
        depo(searchData.company);
        // Clear depo selection when company changes
        setSearchData((curr) => ({ ...curr, bus__depo: "" }));
      } else {
        setDepoData([]);
        setSearchData((curr) => ({ ...curr, bus__depo: "" }));
      }
    }
  }, [searchData.company, depo, loginUser?.user_type]);

  // Company list
  const companyName = async () => {
    try {
      const response = await axios(`${baseUrl}/module/admin/company-list`, {
        method: "GET",
        headers: { Authorization: "Token " + token },
      });
      setCompanyNameData(response?.data?.data || []);
    } catch (error) {
      console.error("company list error:", error);
      setCompanyNameData([]);
    }
  };

  useEffect(() => {
    // Refresh list when page changes
    JobScheduleListApi(pageNumber);
  }, [pageNumber]);

  useEffect(() => {
    depo();
    companyName();
    JobScheduleListApi(1);
  }, []);

  // Search handler - uses same endpoint but without page param initially
  const handleSearch = async (e) => {
    if (e && e.preventDefault) e.preventDefault();

    setPageNumber(1);
    try {
      const qs = new URLSearchParams();
      if (searchData.company) qs.set("company", searchData.company);
      if (searchData.bus__depo) qs.set("bus__depo", searchData.bus__depo);
      if (searchData.cleaning_type)
        qs.set("cleaning_type", searchData.cleaning_type);
      if (searchData.assign_date) qs.set("assign_date", searchData.assign_date);
      if (searchData.bus_bus_number)
        qs.set("bus__bus_number", searchData.bus_bus_number);
      if (
        searchData.report_done !== "" &&
        searchData.report_done !== null &&
        typeof searchData.report_done !== "undefined"
      ) {
        qs.set("report_done", String(searchData.report_done));
      }

      const url = `${baseUrl}/module/admin/adminscheduler-viewset?${qs.toString()}`;

      const response = await axios(url, {
        method: "GET",
        headers: { Authorization: "Token " + token },
      });

      if (response?.data?.code && response.data.code !== 200) {
        // If 404 => no records: set empty array so UI shows "No records found"
        if (response.data.code === 404) {
          setScheduleData([]);
          setPaginationDetails(response?.data?.extra || {});
          setPageLimit(response?.data?.extra?.total || 1);
          setExtra(response?.data?.extra || {});
          ToastMessgae(response.data);
        } else {
          ToastMessgae(response.data);
        }
        return;
      }

      // Normal success flow
      setScheduleData(response?.data?.data || []);
      setPaginationDetails(response?.data?.extra || {});
      setPageLimit(response?.data?.extra?.total || 1);
      setExtra(response?.data?.extra || {});
    } catch (error) {
      console.error("search error:", error);
      alert("some error from Backend");
      setScheduleData([]);
    }
  };

  // Delete handler
  const deleteHandle = (id) => {
    const apiCall = async () => {
      try {
        const response = await axios(
          `${baseUrl}/module/admin/adminscheduler-viewset/${id}`,
          {
            method: "DELETE",
            headers: { Authorization: "Token " + token },
          }
        );

        if (response?.data?.code === 403) {
          return Swal.fire({
            title: `${response.data.message}`,
            icon: "error",
          });
        }

        JobScheduleListApi();
        setScheduleData((prev) =>
          prev.filter((item) => item.id !== response?.data?.data?.id)
        );
      } catch (error) {
        console.error("delete error:", error);
        alert("Delete failed");
      }
    };

    Swal.fire({
      title: "Are you sure..?",
      text: `You won't be able to revert this..!`,
      icon: "info",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, delete it!`,
    }).then((result) => {
      if (result.isConfirmed) {
        apiCall();
        Swal.fire({
          title: "deleted...!",
          text: `Scheduler has been delete..`,
          icon: "success",
        });
      }
    });
  };

  const [viewType, setViewType] = useState("view");
  const handleViewType = (e) => {
    setViewType(e.target.value);
  };

  const [dateError, setDateError] = useState("")

  const handleReset = () => {
    setSearchData({
      company: "",
      bus__depo: "",
      cleaning_type: "",
      assign_date: "",
      bus_bus_number: "",
      report_done: "",
    });
  };
  useEffect(() => {
    handleReset();
  }, [viewType]);

  useEffect(() => {
    setDateError("");
  }, [searchData.assign_date, viewType]);

  return (
    <>
      <Header />
      <Sidebar activeItem={"Rostering"} />
      <section className="main-sec">
        <div className="row">
          <div className="col-lg-12">
            <div className="dashboard-title">
              <h4 className="dash-head">
                <i className="fa fa-suitcase me-2" />
                Job Schedule lobby
              </h4>
              <div>
                <Link
                  to="/depo-list-for-change-scheduling"
                  className="blu-btn me-2"
                >
                  <i className="fa fa-calendar me-2" />
                  change schedule
                </Link>
                <Link to="/job-schedule-form" className="blu-btn">
                  <i className="fa fa-plus me-2" />
                  Add New Job
                </Link>
                {loginUser?.user_type === "ADMIN_MANAGER" && (
                  <>
                    <Link
                      to="#"
                      className="blu-btn ms-2"
                      data-bs-toggle="modal"
                      data-bs-target="#addBulkJobScheduler"
                    >
                      <i className="fa fa-upload me-2" />
                      Add bulk job scheduler
                    </Link>
                    <Link
                      to="#"
                      className="blu-btn ms-2"
                      data-bs-toggle="modal"
                      data-bs-target="#addBulkJobDone"
                    >
                      <i className="fa fa-upload me-2" />
                      Bulk job done
                    </Link>
                  </>
                )}
              </div>
            </div>
            <div className="custom-bredcump">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Job Schedule List ({extra?.count || 0})
                  </li>
                </ol>
              </nav>
            </div>
          </div>

          <div className="col-lg-12">
            <div className="cstm-tab">
              <div className="tab-content " id="myTabContent">
                <div
                  className="tab-pane fade show active"
                  id="tab-01"
                  role="tabpanel"
                >
                  <div className="cards bus-list">
                    <div className="bus-filter">
                      <div className="row justify-content-end">
                        <div className="col-lg-12">
                          <form onSubmit={handleSearch}>
                            <div className="row grid">
                              <div className="col-md-3 mb-3">
                                <label>View Type</label>
                                <select
                                  name="view_type"
                                  onChange={handleViewType}
                                  className="form-select"
                                  value={viewType}
                                >
                                  <option value="view">View</option>
                                  <option value="csv">Download CSV</option>
                                </select>
                              </div>
                              {loginUser?.user_type === "SUPER_ADMIN" && (
                                <div className="col-md-3 mb-3">
                                  <label>Company</label>
                                  <select
                                    name="company"
                                    onChange={ChangeHandler}
                                    className="form-select"
                                    value={searchData.company}
                                  >
                                    <option value="">Select Company</option>
                                    {companyNameData?.map((c) => (
                                      <option key={c?.id} value={c?.id}>
                                        {c?.company_name}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                              )}

                              <div className="col-md-3 mb-3">
                                <label>Depot</label>
                                <select
                                  name="bus__depo"
                                  onChange={ChangeHandler}
                                  className="form-select"
                                  value={searchData.bus__depo}
                                  disabled={
                                    loginUser?.user_type &&
                                    loginUser?.user_type === "SUPER_ADMIN" &&
                                    !searchData.company
                                  }
                                >
                                  <option value="">
                                    {loginUser?.user_type &&
                                    loginUser?.user_type === "SUPER_ADMIN" &&
                                    !searchData.company
                                      ? "Select Company First"
                                      : "Select Depot"}
                                  </option>
                                  {depoData?.map((d) => (
                                    <option key={d?.id} value={d?.id}>
                                      {d?.depo_name}
                                    </option>
                                  ))}
                                </select>
                              </div>

                              <div className="col-md-3 mb-3">
                                <label>Cleaning Type</label>
                                <select
                                  name="cleaning_type"
                                  onChange={ChangeHandler}
                                  className="form-select"
                                  value={searchData.cleaning_type}
                                  disabled={
                                    loginUser?.user_type &&
                                    loginUser?.user_type === "SUPER_ADMIN" &&
                                    viewType === "csv" &&
                                    !searchData.company
                                  }
                                >
                                  <option value="">
                                    {loginUser?.user_type &&
                                    loginUser?.user_type === "SUPER_ADMIN" &&
                                    viewType === "csv" &&
                                    !searchData.company
                                      ? "Select Company First"
                                      : "Select Cleaning Type"}
                                  </option>
                                  <option value="REGULAR_CLEANING">
                                    Regular Cleaning
                                  </option>
                                  <option value="STANDARD_DEEP_CLEANING">
                                    Standard Deep Cleaning
                                  </option>
                                  <option value="ANNUAL_DEEP_CLEANING">
                                    Annual Deep Cleaning
                                  </option>
                                </select>
                              </div>

                              <div className="col-md-3 mb-3">
                                <label>Assign Date</label>
                                <input
                                  onChange={ChangeHandler}
                                  name="assign_date"
                                  type="date"
                                  className="form-control"
                                  placeholder="Assign date Type..."
                                  value={searchData?.assign_date}
                                />
                                {dateError && (<p className="text-red text-sm" style={{color: "red", textAlign: "left", paddingLeft: "4px" }}>
                                  {dateError}*
                                </p>) }
                              </div>

                              <div className="col-md-2 mb-3">
                                <label>Status</label>
                                <select
                                  name="report_done"
                                  onChange={ChangeHandler}
                                  className="form-select"
                                  value={
                                    searchData.report_done === true
                                      ? "true"
                                      : searchData.report_done === false
                                      ? "false"
                                      : ""
                                  }
                                >
                                  <option value="">Select status</option>
                                  <option value="true">Complete</option>
                                  <option value="false">Pending</option>
                                </select>
                              </div>

                              <div className="col-md-3 mb-3">
                                <label>Bus Number</label>
                                  <input
                                  onChange={ChangeHandler}
                                  name="bus_bus_number"
                                  type="text"
                                  className="form-control"
                                  placeholder="Bus Name..."
                                  value={searchData.bus_bus_number}
                                />
                              </div>

                              {viewType === "view" ? (
                                <div className="col-md-2 mb-3">
                                  <label>&nbsp;</label>
                                  <button
                                    className="thm-btn w-100"
                                    type="submit"
                                  >
                                    Search
                                  </button>
                                </div> ) : (
                                (<div className="col-md-2 mb-3">
                                  <label>&nbsp;</label>
                                  <button
                                    disabled={exportLoader}
                                    className={`thm-btn text-white bg-dark border-dark w-100 ${
                                      exportLoader ? "disabled" : ""
                                    }`}
                                    style={{
                                      opacity: exportLoader ? 0.7 : 1,
                                      cursor: exportLoader
                                        ? "not-allowed"
                                        : "pointer",
                                    }}
                                    onClick={handleDownloadReport}
                                    type="button"
                                  >
                                    {exportLoader ? (
                                      <>
                                        <i className="fa fa-spinner fa-spin me-2"></i>{" "}
                                        Downloading...
                                      </>
                                    ) : (
                                      <>
                                        <i className="fa fa-download me-2"></i>{" "}
                                        Download CSV
                                      </>
                                    )}
                                  </button>
                                </div>
                              ))}
                              <div className="col-md-2 mb-3">
                                <label>&nbsp;</label>
                                <button
                                  className="thm-btn w-100"
                                  onClick={handleReset}
                                >
                                  Reset
                                </button>
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>

                    {/* Cards / Empty State */}
                    <div className="row mb-3">
                      {Array.isArray(scheduleData) &&
                      scheduleData.length > 0 ? (
                        scheduleData.map((arr) => (
                          <div
                            key={arr?.id}
                            className="col-lg-3 col-md-6 col-sm-6"
                          >
                            <div className="job-shch-card">
                              {loginUser.user_type === "ADMIN_MANAGER" ||
                              loginUser?.user_type === "CLEANING_MANAGER" ? (
                                <Link
                                  to={`/change-scheduling/${arr?.bus?.depo}`}
                                >
                                  <div className="job-shch-card-img">
                                    <img src={Bus_img} alt="" />
                                  </div>
                                </Link>
                              ) : (
                                <div className="job-shch-card-img">
                                  <img src={Bus_img} alt="" />
                                </div>
                              )}

                              <div className="job-shch-card-cntnt">
                                <p className="date">
                                  <i className="fa fa-calendar-alt me-1" />
                                  {arr?.assign_date}
                                </p>
                                <h5>{arr?.bus?.depo_name}</h5>
                                <p className="assigned">
                                  Bus Number:<span>{arr?.bus?.bus_number}</span>
                                </p>
                                <p className="mb-0">
                                  Depot Address :
                                  <span className="assigned-prfl">
                                    {arr?.bus?.depo_address}
                                  </span>
                                </p>
                              </div>

                              <div className="job-shch-card-bttm">
                                <Link to="#" className="thm-btn">
                                  {arr?.cleaning_type}
                                </Link>

                                <div className="dropdown cstm-menu ">
                                  <button
                                    type="button"
                                    id="jobmenu"
                                    data-bs-toggle={
                                      loginUser?.user_type ===
                                      "CLEANING_MANAGER"
                                        ? undefined
                                        : "dropdown"
                                    }
                                    aria-expanded="false"
                                    disabled={
                                      loginUser?.user_type ===
                                      "CLEANING_MANAGER"
                                    }
                                    className={
                                      arr?.cleaning_type === "REGULAR_CLEANING"
                                        ? "bg-success text-white"
                                        : arr?.cleaning_type ===
                                          "ANNUAL_DEEP_CLEANING"
                                        ? "bg-danger"
                                        : arr?.cleaning_type ===
                                            "STANDARD_DEEP_CLEANING" &&
                                          `bg-warning`
                                    }
                                    style={
                                      loginUser?.user_type ===
                                      "CLEANING_MANAGER"
                                        ? {
                                            opacity: 0.6,
                                            cursor: "not-allowed",
                                          }
                                        : {}
                                    }
                                  >
                                    <i className="fa fa-list" />
                                  </button>

                                  {loginUser?.user_type !==
                                    "CLEANING_MANAGER" && (
                                    <ul
                                      className="dropdown-menu"
                                      aria-labelledby="jobmenu"
                                    >
                                      <li>
                                        <Link
                                          className="dropdown-item"
                                          to={`/job-schedule-edit/${arr?.id}`}
                                        >
                                          Edit
                                        </Link>
                                      </li>
                                      <li>
                                        <Link
                                          onClick={() => deleteHandle(arr.id)}
                                          className="dropdown-item"
                                          to="#"
                                        >
                                          Delete
                                        </Link>
                                      </li>
                                    </ul>
                                  )}
                                </div>

                                {arr.report_done === true ? (
                                  <span className="status complete">
                                    Complete
                                  </span>
                                ) : (
                                  <span className="status pending">
                                    Pending
                                  </span>
                                )}
                              </div>
                            </div>
                          </div>
                        ))
                      ) : (
                        <div className="col-12">
                          <div className="text-center py-5">
                            <img
                              src={Bus_img}
                              alt="no-data"
                              style={{ maxWidth: 120, opacity: 0.6 }}
                            />
                            <h5 className="mt-3">No records found</h5>
                            <p className="mb-0">
                              Try clearing filters or choose different search
                              criteria.
                            </p>
                          </div>
                        </div>
                      )}
                    </div>

                    <Pagination
                      pageNumber={pageNumber}
                      setPageNumber={setPageNumber}
                      pageLimit={pageLimit}
                      paginationDetails={paginationDetails}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <BulkJobSchedulerUpload />
      <BulkJobDoneUpload />
    </>
  );
}
